import { v1 as uuidv1 } from 'uuid';

import AppDispatcher from 'dispatcher/AppDispatcher';
import AuthConstants from 'constants/AuthConstants';
import QualAPI from 'utils/QualAPI';
import QualConstants from 'constants/QualConstants';


var QualCodeActions = {
  /*****************************\
  *
  * AUTH ACTIONS
  *
  \*****************************/
  signUp: function(name, email, password)
  {
    AppDispatcher.handleAction({
      actionType: AuthConstants.AUTH_SIGN_UP,
      data: null
    });

    return QualAPI.signUp(name, email, password).then((response) => {
      AppDispatcher.handleAction({
        actionType: AuthConstants.AUTH_SIGN_UP_RESPONSE,
        data: response
      });
    })
    .catch((error) => {
      AppDispatcher.handleAction({
        actionType: AuthConstants.AUTH_SIGN_UP_ERROR,
        data: ((error.response || {}).data || {})
      });
    });
  },

  signIn: function(email, password, mfaCode)
  {
    AppDispatcher.handleAction({
      actionType: AuthConstants.AUTH_SIGN_IN,
      data: null
    })

    QualAPI.signIn(email, password, mfaCode).then((response) => {
      AppDispatcher.handleAction({
        actionType: AuthConstants.AUTH_SIGN_IN_RESPONSE,
        data: response
      })
    })
    .catch((error) => {
      const errorData = (error.response || {}).data;
      if (errorData && errorData.mfa_required) {
        // MFA required - may include error message for invalid code
        const errorMessage = errorData.errors && errorData.errors.length > 0
          ? errorData.errors[0]
          : null;
        AppDispatcher.handleAction({
          actionType: AuthConstants.AUTH_MFA_REQUIRED,
          data: { email, error: errorMessage }
        });
      } else {
        AppDispatcher.handleAction({
          actionType: AuthConstants.AUTH_SIGN_IN_ERROR,
          data: errorData
        });
      }
    });
  },

  signOut: function()
  {
    AppDispatcher.handleAction({
      actionType: AuthConstants.AUTH_SIGN_OUT,
      data: null
    });

    return QualAPI.signOut().then(() => {
      AppDispatcher.handleAction({
        actionType:AuthConstants.AUTH_SIGN_OUT_RESPONSE,
        data: null
      })
    })
    .catch(function (error) {
      AppDispatcher.handleAction({
        actionType:AuthConstants.AUTH_SIGN_OUT_RESPONSE,
        data: null
      })
    });
  },

  showPasswordModal: function(show)
  {
    AppDispatcher.handleAction({
      actionType: AuthConstants.AUTH_CHANGE_PASSWORD_MODAL,
      data: {
        show: show
      }
    });
  },

  changePassword: function(currentPassword, newPassword, verificationPassword)
  {
    AppDispatcher.handleAction({
      actionType: AuthConstants.AUTH_NEW_PASSWORD,
      data: {}
    })

    QualAPI.changePassword(currentPassword, newPassword, verificationPassword).then((response)=>{
      AppDispatcher.handleAction({
        actionType: AuthConstants.AUTH_NEW_PASSWORD_RESPONSE,
        data: response.data
      })
    }).catch((error)=>{
      AppDispatcher.handleAction({
        actionType: AuthConstants.AUTH_NEW_PASSWORD_ERROR,
        // A network error has no response at all.
        data: (error.response && error.response.data) || {},
        error: true
      })
    });
  },

  forgotPassword: function(email)
  {
    AppDispatcher.handleAction({
      actionType: AuthConstants.AUTH_FORGOT_PASSWORD,
      data:{},
    })

    QualAPI.forgotPassword(email).then((response)=>{
      AppDispatcher.handleAction({
        actionType: AuthConstants.AUTH_FORGOT_PASSWORD_RESPONSE,
        data: response.data
      });
    }).catch((error)=>{
      // TODO: sadly lots of ways errors could come in...
      AppDispatcher.handleAction({
        actionType: AuthConstants.AUTH_FORGOT_PASSWORD_ERROR,
        data: error.response,
        errors: error.response.data,
      });
    });
  },

  acceptInvite: function(token, newPassword, verificationPassword, name)
  {
    AppDispatcher.handleAction({
      actionType: AuthConstants.AUTH_ACCEPT_INVITE,
      data:{},
    })

    QualAPI.acceptInvite(token, newPassword, verificationPassword, name).then((response)=>{
      AppDispatcher.handleAction({
        actionType: AuthConstants.AUTH_ACCEPT_INVITE_RESPONSE,
        data: response.data
      })
    }).catch((error)=>{
      // TODO: sadly lots of ways errors could come in...
      AppDispatcher.handleAction({
        actionType: AuthConstants.AUTH_ACCEPT_INVITE_ERROR,
        data: error.response,
        errors: error.response.data,
      })
    });
  },

  updateAuthToken: function(headers)
  {
    AppDispatcher.handleAction({
      actionType: AuthConstants.AUTH_UPDATE_TOKEN,
      data: headers
    })
  },

  /*****************************\
  *
  * Projects
  *
  \*****************************/

  sendFeedback: function(feedback)
  {
    return QualAPI.sendFeedback(feedback)
  }
}

export default QualCodeActions
